
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$gsap.context(() => {
        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: this.$refs.seal,
              start: 'top bottom-=10%',
              // end: 'max',
              // markers: true,
            },
          })
          .from(this.$refs.seal, {
            opacity: 0,
            duration: 0.5,
          })
          .from(
            '.rings',
            {
              transformOrigin: 'center',
              rotate: 90,
              duration: 1,
            },
            '<'
          )
      }, this.$refs.seal)
    })
  },
}
